//基础信息
const Group = () => import(/*webpackChunkName:'operation'*/'@/page/operation/basicInformation/group.vue')//group
const Property = () => import(/*webpackChunkName:'operation'*/"@/page/operation/basicInformation/property.vue")//property
const Park = () => import(/*webpackChunkName:'operation'*/'@/page/operation/basicInformation/park.vue')//park

const RouteTemp = () => import(/*webpackChunkName:'operation'*/'@/page/commons/routeTemp.vue')

export const basicInfo=
    {
        path: '/main/base',
        name: '基础信息',
        meta: {
            requireAuth: true,
        },
        component: RouteTemp,
        children: [
            {
                path: '/main/businessManagement/realty',
                name: '物业管理',
                meta: {
                    requireAuth: true,
                },
                component: Property
            },
            {
                path: '/main/businessManagement/group',
                name: '集团管理',
                meta: {
                    requireAuth: true,
                },
                component: Group
            },
            {
                path: '/main/park/parklist',
                name: '车场管理',
                component: Park,
                meta: {
                    requireAuth: true,
                },
            },

        ]
    }
